export const roadmap = [
  {
    key: "done",
    title: "Done",
    items: [
      {
        id: "project-launch",
        title: "Project Launch",
        desc: "First generative PFP collection on Tezos, minted on hicetnunc.",
        status: "done",
        quarter: "2021",
      },
      {
        id: "rarity-tool",
        title: "Public Rarity Tool",
        desc: "Open trait ranks and spotlight support.",
        status: "done",
        quarter: "2025",
      },
      {
        id: "statistics",
        title: "Analytics & Statistics",
        desc: "Comprehensive analytics dashboard with collection metrics.",
        status: "done",
        quarter: "2025",
      }
    ]
  },
  {
    key: "now",
    title: "Now",
    items: [
      {
        id: "artist-floor-mints",
        title: "Artist Mints to Support the Floor",
        desc: "Centaur drops that recycle proceeds into floor buys.",
        status: "ongoing"
      },
      {
        id: "site-stats",
        title: "Add Strong Statistics to Site",
        desc: "On-chain stats and collection metrics presented cleanly.",
        status: "ongoing"
      },
      {
        id: "shareable-videos",
        title: "People — Ready-to-Share Videos",
        desc: "Short social clips hosted on the site for collectors.",
        status: "ongoing"
      },
      {
        id: "sweep-buy-floor",
        title: "Sweep / Buy-the-Floor Option",
        desc: "Simple UI to sweep floor pieces from the site.",
        status: "ongoing"
      }
    ]
  },
  {
    key: "next",
    title: "Next",
    items: [
      {
        id: "collector-badges",
        title: "Collector Badges",
        desc: "Lightweight wallet badges and spotlight queue.",
        status: "planned"
      },
      {
        id: "trait-explorer-tweaks",
        title: "Trait Explorer Tweaks",
        desc: "UI polish and faster compares for traits.",
        status: "planned"
      },
      {
        id: "micro-drops",
        title: "Micro Drops → Floor Actions",
        desc: "Tiny themed drops to fund small floor sweeps.",
        status: "planned"
      }
    ]
  }
];

